import { FORTA_WHITE } from '../../../../utils/colors';

import type { SxProps, Theme } from '@mui/material';

export const ASSESSMENT_BACKDATE_CONTAINER_SX: SxProps<Theme> = {
  flex: 1,
  borderRadius: '8px',
  backgroundColor: FORTA_WHITE,
  boxShadow: 'none',
  mb: 2,
};

export const ASSESSMENT_BACKDATE_HEADER_SX: SxProps<Theme> = {
  background: 'transparent',
  borderRadius: 0,
  boxShadow: 'none',
};

export const ASSESSMENT_BACKDATE_ROW_SX: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
};
